import * as React from 'react'
import { IActiveTripResponseV2 } from '../../types'
import { convertDollarsToCents } from '../../utils'
import UIMessages from 'src/utils/ui-messages'
import Switcher from '../ui/Switcher'

enum PaymentCompletionTypes {
  COMPLETE_WITH_PAYMENT = 0,
  COMPLETE_WITHOUT_PAYMENT = 1
}

interface IManualTripCompleteFormProps {
  currentTrip: IActiveTripResponseV2
  onSubmit: (
    tripId: string,
    paymentRequired: boolean,
    tripPrice?: number,
    comment?: string,
    disableNotification?: boolean
  ) => Promise<void>
  loading?: boolean
}

interface IManualTripCompleteFormState {
  completionType: PaymentCompletionTypes
  completionReason: string
  tripPrice: number
  disableNotification: boolean
}

export default class ManualTripCompleteForm extends React.Component<
  IManualTripCompleteFormProps,
  IManualTripCompleteFormState
> {
  public static formOptions = [
    {
      label: 'Complete with payment',
      value: PaymentCompletionTypes.COMPLETE_WITH_PAYMENT,
      apiData: {
        paymentRequired: true
      }
    },
    {
      label: 'Complete, no payment',
      value: PaymentCompletionTypes.COMPLETE_WITHOUT_PAYMENT,
      apiData: {
        paymentRequired: false
      }
    }
  ]

  public state = {
    completionType: PaymentCompletionTypes.COMPLETE_WITH_PAYMENT,
    completionReason: '',
    tripPrice: (this.props.currentTrip.estimatedFare || 0) / 100,
    disableNotification: true
  }

  public render() {
    return (
      <form onSubmit={this.onSubmit}>
        <div>
          <label>{UIMessages.manualTripComplete.completionTypeLabel}</label>
          {ManualTripCompleteForm.formOptions.map(({ label, value }) => (
            <div className='mb1' key={`completion-type-options-${value}`}>
              <label>
                <input
                  type='radio'
                  value={value}
                  checked={this.state.completionType === value}
                  onChange={this.onPaymentDetailsChange}
                  disabled={this.props.loading}
                />
                {label}
              </label>
            </div>
          ))}
        </div>
        {this.tripPriceInput()}
        <div className='mt2 flex items-center'>
          <div className='mr1 hidden'>
            {/* Hide the toggle */}
            {/* <Switcher state={this.state.disableNotification} click={this.notificationPrefToggle} /> */}
          </div>
          {/* <label>{UIMessages.manualTripComplete.notificationControlLabel}</label> */}
        </div>
        <div className='mt2'>
          <label htmlFor='completionReason'>{UIMessages.manualTripComplete.completionReasonLabel}</label>
          <textarea
            id='completionReason'
            className='col-12 p1 fit'
            placeholder='Add reason'
            disabled={this.props.loading}
            onChange={this.onMessageChange}
            value={this.state.completionReason}
          />
        </div>
        <div className='mt1'>{this.props.children}</div>
      </form>
    )
  }

  private tripPriceInput = () => {
    if (this.state.completionType === PaymentCompletionTypes.COMPLETE_WITH_PAYMENT) {
      return (
        <div className='mt2'>
          <label htmlFor='tripCost'>{UIMessages.manualTripComplete.tripPriceLabel}</label>
          <input
            id='tripCost'
            className='p1 fit ml1'
            placeholder='Trip cost'
            type='number'
            disabled={this.props.loading}
            onChange={this.onCostChange}
            value={this.state.tripPrice}
          />
        </div>
      )
    }
    return
  }

  private onCostChange = (e: any) => {
    this.setState({ tripPrice: parseFloat(e.target.value) })
  }

  private onPaymentDetailsChange = (e: any) => {
    this.setState({
      completionType: parseInt(e.target.value, 10)
    })
  }

  private onMessageChange = (e: any) => {
    this.setState({
      completionReason: e.target.value
    })
  }

  private notificationPrefToggle = () => {
    this.setState({
      disableNotification: !this.state.disableNotification
    })
  }

  private onSubmit = async (e: any) => {
    e.preventDefault()
    const currentTrip = this.props.currentTrip
    const selectedCompletionType = ManualTripCompleteForm.formOptions.find(({ value }) => {
      return value === this.state.completionType
    })
    const processPayment = selectedCompletionType ? selectedCompletionType.apiData.paymentRequired : false

    const customTripPrice = +convertDollarsToCents(this.state.tripPrice).toFixed(2)

    // if the trip price in state is just the same with the custom trip price value,
    // no need to pass the price value
    const tripPrice = +(currentTrip.estimatedFare || 0).toFixed(2) === customTripPrice ? undefined : customTripPrice

    await this.props.onSubmit(
      currentTrip.id,
      processPayment,
      processPayment ? tripPrice : undefined,
      this.state.completionReason,
      this.state.disableNotification
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/ManualTripCompleteForm.tsx